import {
  REQUEST_SECURE_URL_LOADING,
  REQUEST_SECURE_URL_SUCCESS,
  REQUEST_SECURE_URL_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { createNewItemService } from "services/createNewItemService";
import { notification } from "antd";
import { requestSecureUrlUrl } from "api/apiUrls";

export const requestSecureUrlActions =
  (lang: any, userId: any, data: any, callback?: any) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch({ type: REQUEST_SECURE_URL_LOADING, payload: true });
      const response: any = await createNewItemService(
        `${requestSecureUrlUrl}${lang}/user/${userId}/post`,
        data,
        "",
        "json"
      );

      if (response.status === 200) {
        notification.success({
          message: `${response?.data?.status}`,
        });

        callback(response.data);
      } else {
        notification.error({
          message: "Something went wrong please try agian",
        });
      }

      dispatch({ type: REQUEST_SECURE_URL_SUCCESS, payload: response.data });
    } catch (err: any) {
      dispatch({ type: REQUEST_SECURE_URL_FAILURE, payload: err });
      notification.error({
        message: "Something went wrong please try agian",
      });
    } finally {
      dispatch({ type: REQUEST_SECURE_URL_LOADING, payload: false });
    }
  };
